import Vue from 'vue'
import store from '../store'

export default [
  {
    path: '/balancetes',
    name: 'balancetes-index',
    beforeEnter: async (to, from, next) => {
      await store.dispatch('getPaginateBalancetes')
      next()
    },
    meta: {
      title: 'Balancetes',
      paginateMethod: 'getPaginateBalancetes',
      paginateAttr: 'paginateBalancetes',
      twoLines: true,
      subtitleAttr: item => Vue.options.filters.date(item['data_visita']),
      titleAttr: item => item['nome'],
      routeToEdit: 'balancetes-details-index',
      emptyList: 'Nenhum balancete foi importado.',
      avatarIcon: 'poll',
      pageAttr: 'balancetePage',
      pageCommit: 'setBalancetePage',
      filterAttr: 'balanceteFilter',
      filterCommit: 'setBalanceteFilter',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/paginate')
    }
  },
  {
    path: '/balancetes/:id/importar',
    name: 'balancetes-importar-index',
    props: true,
    meta: {
      title: 'Importar dados de balancete',
      requireAuth: true
    },
    beforeEnter: async (to, from, next) => {
      await store.dispatch('getVisita', {
        id: Number(to.params.id)
      })
      next()
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/balancete/upload'
      )
    }
  },
  {
    path: '/balancetes/:id',
    name: 'balancetes-details-index',
    props: true,
    beforeEnter: async (to, from, next) => {
      await store.dispatch('getBalancete', {
        id: Number(to.params.id)
      })
      next()
    },
    meta: {
      title: 'Balancete mensal',
      requireAuth: true
    },
    component: function () {
      return import(
        /* webpackChunkName: "routes" */ '@/views/balancete/detalhe'
      )
    }
  }
]
